import React, { useState } from 'react';
import DisconnectedCalendarAlert from '../DisconnectedCalendarAlert';

export default function UserNotificationsWrapper() {
  const [wrapperActive, setWrapperActive] = useState(true);

  const handleClose = () => {
    setWrapperActive(false);
  };

  return (
    wrapperActive && (
      <div>
        <DisconnectedCalendarAlert handleClose={handleClose} />
      </div>
    )
  );
}
